import { render, staticRenderFns } from "./PosUpdaterV2.vue?vue&type=template&id=1f1116de&scoped=true&"
import script from "./PosUpdaterV2.vue?vue&type=script&lang=js&"
export * from "./PosUpdaterV2.vue?vue&type=script&lang=js&"
import style0 from "./PosUpdaterV2.vue?vue&type=style&index=0&id=1f1116de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1116de",
  null
  
)

export default component.exports